import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputTextArea',
  props: {
    value: null
  },
  emits: ["input", "focus", "blur"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: 'input', value: string): void;
	(e: 'focus'): void;
	(e: 'blur'): void;
}), expose: any, slots: any, attrs: any }) {





const input = ref<HTMLInputElement | null>(null);

function onInput(e: Event) {
	emit('input', (e.target as HTMLTextAreaElement).value);
}

expose({ input });

return { __sfc: true,emit, input, onInput }
}

})